module.exports = __webpack_public_path__ + "../resources/img/pictogram_back.5ec9fae6.png";